import { useEffect, useRef, useState } from "react";

/**
 * Inline text field for naming a folder: Enter or leaving the field saves, Escape cancels.
 * Empty names cancel too (nothing to save).
 */
export function FolderNameInput({
  initial = "",
  label,
  placeholder,
  onSave,
  onCancel,
}: Readonly<{
  initial?: string;
  label: string;
  placeholder: string;
  onSave: (name: string) => void;
  onCancel: () => void;
}>) {
  const [value, setValue] = useState(initial);
  const done = useRef(false);
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    ref.current?.focus();
    ref.current?.select();
  }, []);

  const finish = (save: boolean) => {
    if (done.current) return;
    done.current = true;
    const name = value.trim();
    if (save && name && name !== initial) onSave(name);
    else onCancel();
  };

  return (
    <input
      ref={ref}
      aria-label={label}
      placeholder={placeholder}
      value={value}
      maxLength={80}
      onChange={(event) => setValue(event.target.value)}
      onBlur={() => finish(true)}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          finish(true);
        } else if (event.key === "Escape") {
          event.preventDefault();
          finish(false);
        }
      }}
      className="w-full min-w-0 rounded-md border border-border-input bg-surface-elevated px-2 py-1 text-xs text-content-primary outline-none focus:border-border-focus"
    />
  );
}
